import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import CampaignModal from '@/components/campaign/CampaignModal';
import MenuButton from '@/components/common/MenuButton';
import useCampaignForm from '@/lib/hooks/useCampaignForm';
import { useCurrentUser } from '@/lib/hooks/userData';
import translate from '@/lib/intl/translate';
import CampaignType from '@/propTypes/CampaignType';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
function CampaignMenu({ campaign }: any) {
  const { isOrgAdmin, isOrgEditor } = useCurrentUser();
  const id = 'feed-slider-menu';
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO(ts-migrate)
  const openMenu = (e: any) => setMenuAnchor(e.currentTarget);
  const closeMenu = () => setMenuAnchor(null);
  const {
    // modal state related
    isCampaignModalOpen,
    openCampaignModal,
    closeCampaignModal,
    lockedFields,
    modalData,
    setModalData,
    modalErrors,
    setModalErrors,

    // api related
    compaignApiError,
    isCampaignSaving,
    saveCampaign,
    teamMembers,
  } = useCampaignForm();

  const items = [
    {
      label: translate('EDIT'),
      onClick: () => {
        openCampaignModal(campaign);
        setMenuAnchor(null);
      },
    },
  ];
  const showControls = items.length && (isOrgAdmin || isOrgEditor);

  return showControls ? (
    <>
      <MenuButton
        onClick={openMenu}
        className="ml-4 text-text-secondary"
        aria-controls={menuAnchor ? id : undefined}
        aria-haspopup="true"
      />
      <Menu
        id={id}
        onClose={closeMenu}
        open={!!menuAnchor}
        anchorEl={menuAnchor}
      >
        {items.map(({ label, onClick }) => (
          <MenuItem key={label} onClick={onClick}>
            {label}
          </MenuItem>
        ))}
      </Menu>
      <CampaignModal
        data={modalData}
        teamMembers={teamMembers}
        errors={modalErrors}
        handleClose={closeCampaignModal}
        handleSave={saveCampaign}
        hasApiError={Boolean(compaignApiError)}
        // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'campaignId' does not exist on type '{ as... Remove this comment to see the full error message
        isCreating={!modalData.campaignId}
        isLoading={isCampaignSaving}
        lockedFields={lockedFields}
        open={isCampaignModalOpen}
        updateData={setModalData}
        updateErrors={setModalErrors}
      />
    </>
  ) : null;
}

CampaignMenu.propTypes = {
  campaign: PropTypes.shape(CampaignType).isRequired,
};

export default CampaignMenu;
